module.exports = __webpack_public_path__ + "facebook-white.png";